export default "__VITE_ASSET__D_YGpG7H__"